import styles from "./styles.module.css"
import { useNavigate } from "react-router-dom";

function SegmentCard({img, segmentName, segmentId}) {
    const navigate = useNavigate()
    return(
        <li className={styles.cardContainer} onClick={() => navigate(`/simulador/${segmentId}`)}>
            <div style={{backgroundImage: `url(${img})`}} className={styles.cardImgWrapper} />
            <div className={styles.cardContent}>
                <div>
                    <div style={{fontWeight: "300"}}>Consórcio de</div>
                    <h4 className={styles.segmentTitle}>{segmentName}</h4>
                </div>
                <h6>
                    Simule Agora
                </h6>
            </div>
        </li>
    )
}

export default SegmentCard